// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCe4T3pnZqyoyqZVmGFpY30ILe9E1zkXdM',
    authDomain: 'invoiceapp-394f1.firebaseapp.com',
    projectId: 'invoiceapp-394f1',
    storageBucket: 'invoiceapp-394f1.appspot.com',
    messagingSenderId: '323919667989',
    appId: '1:323919667989:web:3262b3f56707800978ff1c',
    measurementId: 'G-J2VKMBZDKX',
  },
  // url: 'https://now6.getdesignworks.com/',
  url: 'https://api.sapgeekeyy.com/',

  newUrl: 'https://sapgeekeyy.com:8456/',
  // newUrl: 'http://3.108.72.20:8456/',
  //'https://3.108.72.20:8452/',
  userData: [],
};

// live Url :: https://now2.getdesignworks.com

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
